import React from "react";

const ForgotPassword = ({ setShowModal, showModal }) => {
  return (
  <div
    className="flex justify-center items-center md:w-full backdrop-blur-[1px] bg-black/40 overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
    <div className="flex my-6 mx-auto max-w-3xl">
      <div className="border-0 rounded-lg shadow-lg relative flex flex-col lg:w-96 bg-white outline-none focus:outline-none">
        <div className="flex items-start justify-between p-5 rounded-t ">
          <h3 className="text-1xl font-semibold mx-auto">Forgot Password?</h3>
        </div>
        <div class="md:w-12/12 lg:w-12/12 mx-10 mb-5 mt-2">
          <form>
            <div class="mb-8">
              <label for="formFileDisabled" class="form-label text-sm inline-block text-gray-700 mb-2">Email</label>
              <input
                type="text"
                class="form-control bg-gray-100 block w-full px-4 py-2 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                placeholder="email or phone number"
              />
            </div>

            <button
              // type="submit"
              class="inline-block px-7 py-3 bg-[#CE102C] text-white font-medium text-sm leading-snug uppercase rounded-full shadow-md hover:bg-[#CE102C] hover:shadow-lg focus:bg-[#CE102C] focus:shadow-lg focus:outline-none focus:ring-0 active:bg-[#CE102C] active:shadow-lg transition duration-150 ease-in-out w-full"
              data-mdb-ripple="true"
              

              data-mdb-ripple-color="light"
            >
              Sign up
            </button>

          </form>
        </div>
      </div>
      <div onClick={() => setShowModal(0)} className="flex ml-3 justify-center ml-3 items-center rounded-full bg-white h-5 w-5">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
        </div>
    </div>
  </div>)
}

export default ForgotPassword